module.exports = __webpack_public_path__ + "static/media/wDark_rainy.dc3e1655.svg";